<ng-container
  *ngIf="{
    username: username$ | async,
    shouldHideMenu: shouldHideMenu$ | async
  } as data"
>
  <tg-mobile-menu
    *ngIf="data.username && !isRefreshInProgress && !data.shouldHideMenu"
    class="d-block d-md-none"
    [entries]="menuEntries$ | async"
    [isGym]="isGym$ | async"
  ></tg-mobile-menu>

  <div class="d-flex">
    <div
      *ngIf="data.username && !isRefreshInProgress && !data.shouldHideMenu"
      class="menu-section d-none d-md-block"
      [class.collapsed]="menuCollapsed"
    >
      <tg-main-menu
        [isGym]="isGym$ | async"
        [entries]="menuEntries$ | async"
        [collapsed]="menuCollapsed"
        (toggleCollapse)="toggleMenu()"
      ></tg-main-menu>
    </div>
    <div
      class="content-section"
      [class.noUserLogged]="!data.username || isRefreshInProgress"
      [class.no-menu]="data.shouldHideMenu"
      [class.menu-collapsed]="
        menuCollapsed &&
        data.username &&
        !isRefreshInProgress &&
        !data.shouldHideMenu
      "
    >
      <div
        class="top-bar d-flex"
        *ngIf="data.username && !isRefreshInProgress && !data.shouldHideMenu"
      >
        <span class="gymName align-self-center">
          {{ gymName$ | async }}
        </span>
        <div class="ml-auto">
          <div class="d-flex menu-right">
            <div class="notification">
              <img
                src="../assets/images/menu/notification.png"
                alt=""
                class="notification-icon"
              />
            </div>

            <div
              *ngIf="smsNotificationsEnabled$ | async"
              class="
                sms
                d-flex
                flex-column
                justify-content-center
                align-items-center
              "
            >
              <span>{{ (smsNumber$ | async) || 0 }}</span> SMS
            </div>

            <div class="translation">
              <div
                class="button-wraper"
                ngbDropdown
                placement="bottom-right"
                [autoClose]="true"
              >
                <button
                  type="button"
                  class="profileMenu"
                  id="dropdownLanguage"
                  ngbDropdownToggle
                >
                  <div
                    class="d-flex align-items-center"
                    *ngIf="selectedLanguage"
                  >
                    <img
                      class="flag-icon mr-2"
                      [src]="
                        'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/2.8.0/flags/1x1/' +
                        selectedLanguage.flag +
                        '.svg'
                      "
                      alt="flag"
                    />
                    <span>{{ selectedLanguage.name }}</span>
                  </div>
                </button>

                <div ngbDropdownMenu aria-labelledby="dropdownLanguage">
                  <a
                    ngbDropdownItem
                    class="sideMenuItem d-flex align-items-center"
                    *ngFor="let lang of availableLanguages"
                    (click)="changeLanguage(lang.code)"
                  >
                    <img
                      class="flag-icon mr-2"
                      [src]="
                        'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/2.8.0/flags/1x1/' +
                        lang.flag +
                        '.svg'
                      "
                      alt="flag"
                    />
                    <span>{{ lang.name }}</span>
                  </a>
                </div>
              </div>
            </div>

            <div class="avatar">
              <div *ngIf="!(impersonated$ | async); else imporsonateMenu">
                <div
                  class="d-inline-block mr-2 button-wraper"
                  ngbDropdown
                  #filterDrop="ngbDropdown"
                  placement="bottom-right"
                  [autoClose]="true"
                >
                  <button
                    type="button"
                    class="profileMenu exitImpersonation"
                    id="dropdownFilter"
                    ngbDropdownToggle
                  >
                    <div class="d-flex align-items-center">
                      <span class="avatar-placeholder"></span>
                      <span class="avatar-name">
                        {{ data.username }}
                      </span>
                    </div>
                  </button>
                  <div ngbDropdownMenu aria-labelledby="dropdownFilter">
                    <a
                      ngbDropdownItem
                      class="sideMenuItem"
                      [routerLink]="['/profile']"
                    >
                      {{ TranslationEnum.Menu.PROFILE | translate }}
                    </a>
                    <span
                      ngbDropdownItem
                      class="sideMenuItem"
                      (click)="logout()"
                      >{{ TranslationEnum.Menu.LOG_OUT | translate }}
                    </span>
                  </div>
                </div>
              </div>

              <ng-template #imporsonateMenu>
                <div
                  class="d-inline-block button-wraper"
                  ngbDropdown
                  #myDrop="ngbDropdown"
                  *ngIf="impersonated$ | async"
                >
                  <button
                    type="button"
                    class="exitImpersonation"
                    id="dropdownManual"
                    ngbDropdownAnchor
                    (focus)="myDrop.open()"
                  >
                    <div class="d-flex align-items-center">
                      <span class="avatar-placeholder"></span>
                      <span class="avatar-name">
                        {{ data.username }}
                      </span>
                    </div>
                  </button>
                  <div ngbDropdownMenu aria-labelledby="dropdownManual">
                    <span
                      ngbDropdownItem
                      (click)="exitImpersonation()"
                      class="sideMenuItem"
                    >
                      Exit Impersonation
                    </span>
                    <span ngbDropdownItem class="sideMenuItem">
                      {{ TranslationEnum.Menu.PROFILE | translate }}
                    </span>
                    <span
                      ngbDropdownItem
                      class="sideMenuItem"
                      (click)="logout()"
                      >{{ TranslationEnum.Menu.LOG_OUT | translate }}
                    </span>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

      <div
        class="unpaid-invoices-banner d-flex align-items-center"
        [class.suspended]="gymSuspended"
        *ngIf="
          showUnpaidBanner &&
          (gymSuspended || !unpaidBannerDismissed) &&
          data.username &&
          !isRefreshInProgress &&
          !data.shouldHideMenu
        "
      >
        <span>
          {{
            (gymSuspended
              ? TranslationEnum.Invoices.SUSPENDED_BANNER
              : TranslationEnum.Invoices.UNPAID_BANNER
            ) | translate
          }}
        </span>
        <a
          *ngIf="canViewInvoices"
          class="banner-link ml-2"
          [routerLink]="'/invoices'"
        >
          {{ TranslationEnum.Invoices.UNPAID_BANNER_LINK | translate }}
        </a>
        <span
          *ngIf="!gymSuspended"
          class="banner-close ml-auto"
          (click)="unpaidBannerDismissed = true"
          >&times;</span
        >
      </div>

      <div class="main-content">
        <router-outlet></router-outlet>
      </div>

      <div
        *ngIf="!data.shouldHideMenu"
        class="
          bottom-bar
          d-flex
          justify-content-between
          flex-column flex-md-row
        "
      >
        <ul class="footer-menu d-flex">
          <li *ngFor="let item of footerMenu">
            <a href="{{ item.link }}">
              {{ item.label }}
            </a>
          </li>
        </ul>

        <span class="copy">Copyrights © SmartGym</span>
      </div>
    </div>
  </div>

  <tg-unpaid-invoices-modal
    *ngIf="showUnpaidModal && data.username && !isRefreshInProgress"
    [status]="unpaidStatus"
    [suspended]="gymSuspended"
    [blocking]="isUnpaidModalBlocking"
    [canViewInvoices]="canViewInvoices"
    (dismissed)="dismissUnpaidModal()"
    (viewInvoices)="goToInvoices()"
    (loggedOut)="logout()"
  ></tg-unpaid-invoices-modal>

  <div
    *ngIf="data.username && showCheckIn"
    class="background"
    (click)="changeModalState()"
  ></div>

  <app-check-in
    *ngIf="showCheckIn"
    class="check-in"
    [class.show]="showCheckIn"
    [checkInResponse]="checkInResponse"
    [memberships]="checkInResponse?.membershipCheckIns"
    [memberId]="checkInResponse?.memberId"
    [memberName]="checkInResponse?.username"
    [locationId]="locationId"
    [checkin]="checkInResponse?.status !== barcodeCheck.CHECKED_OUT"
    (close)="changeModalState()"
  ></app-check-in>
</ng-container>
